import React, { useState } from "react";
import ProductGrid from "./ProductGrid";
import Pagination from "@mui/material/Pagination";
import LoadingCard from "../Cards/LoadingCard";

const FilterAllProduct = ({
  loading,
  products,
  addToCartProduct,
  addToWishListProduct,
  addToCompareListProduct,
  page,
  handlePageChange,
  carts,
  removeFromCart,
  decrementQuantity,
  incrementQuantity,
  onRegionChange,
  filter,
  iseuro,
  sort,
  onSortChange,
  onOpenFilterDrawer,
  onClearAll,
  ...props
}) => {
  const totalRecords = Number(filter?.totalRecords) || 0;
  const limit = Number(filter?.limit) || 12;
  const currentPage = Number(filter?.page) || 1;
  const pageCount = Math.max(1, Math.ceil(totalRecords / limit));
  const rangeStart = totalRecords === 0 ? 0 : (currentPage - 1) * limit + 1;
  const rangeEnd = Math.min(currentPage * limit, totalRecords);

  return (
    <div className="col-lg-9">
      <div className="gpshop-toolbar">
        <div className="gpshop-toolbar-left">
          <button
            className="gpshop-mobile-filter-btn"
            onClick={onOpenFilterDrawer}
            type="button"
            aria-label="Open filters"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="4" y1="6" x2="20" y2="6" />
              <line x1="7" y1="12" x2="17" y2="12" />
              <line x1="10" y1="18" x2="14" y2="18" />
            </svg>
            Filters
          </button>
          <div className="gpshop-count">
            {loading ? (
              <span className="gpshop-count-skel" />
            ) : totalRecords > 0 ? (
              <>
                <strong>{totalRecords.toLocaleString()}</strong>
                {totalRecords === 1 ? " product" : " products"}
                <span className="gpshop-count-range">
                  {" "}
                  · showing {rangeStart}–{rangeEnd}
                </span>
              </>
            ) : (
              <span className="gpshop-count-muted">No products</span>
            )}
          </div>
        </div>

        <div className="gpshop-toolbar-right">
          <label className="gpshop-sort">
            <span>Sort:</span>
            <select
              value={sort || "featured"}
              onChange={(e) => onSortChange && onSortChange(e.target.value)}
            >
              <option value="featured">Featured</option>
              <option value="price-asc">Price: Low to High</option>
              <option value="price-desc">Price: High to Low</option>
              <option value="name-asc">Name: A → Z</option>
              <option value="name-desc">Name: Z → A</option>
            </select>
          </label>
        </div>
      </div>

      {loading ? (
        <div className="grid-3 w-full">
          {new Array(filter?.limit || 8).fill(1)?.map((_, i) => (
            <LoadingCard key={i} />
          ))}
        </div>
      ) : products.length === 0 ? (
        <div className="gpshop-empty">
          <div className="gpshop-empty-icon" aria-hidden="true">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <circle cx="11" cy="11" r="7" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
              <line x1="8" y1="11" x2="14" y2="11" />
            </svg>
          </div>
          <h3>No products found</h3>
          <p>Try adjusting your filters or search terms.</p>
          {onClearAll && (
            <button className="gpshop-empty-btn" onClick={onClearAll}>
              Reset filters
            </button>
          )}
          {pageCount > 1 && (
            <div className="flex-justify-center-items-center pt-20 pb-20">
              <Pagination
                count={pageCount}
                size={"large"}
                page={currentPage}
                onChange={handlePageChange}
              />
            </div>
          )}
        </div>
      ) : (
        <div>
          <ProductGrid
            addToCartProduct={addToCartProduct}
            addToWishListProduct={addToWishListProduct}
            addToCompareListProduct={addToCompareListProduct}
            products={products}
            carts={carts}
            removeFromCart={removeFromCart}
            decrementQuantity={decrementQuantity}
            incrementQuantity={incrementQuantity}
            {...props}
          />
          {pageCount > 1 && (
            <div className="flex-justify-center-items-center pt-30 pb-20 gpshop-pagination">
              <Pagination
                count={pageCount}
                size={"large"}
                page={currentPage}
                onChange={handlePageChange}
              />
            </div>
          )}
        </div>
      )}

      <style>{`
        .gpshop-toolbar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 14px;
          padding: 12px 16px;
          background: #15110a;
          border: 1px solid rgba(212, 168, 87, 0.18);
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
          margin-bottom: 14px;
          flex-wrap: wrap;
        }
        .gpshop-toolbar-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }
        .gpshop-toolbar-right {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .gpshop-count {
          font-size: 13px;
          color: #cfd2d6;
        }
        .gpshop-count strong { color: #d4a857; font-weight: 700; }
        .gpshop-count-range { color: #6b7280; font-size: 12px; }
        .gpshop-count-muted { color: #6b7280; font-style: italic; }
        .gpshop-count-skel {
          display: inline-block;
          width: 140px;
          height: 14px;
          border-radius: 4px;
          background: linear-gradient(90deg, #1a1208 25%, #2a1f10 50%, #1a1208 75%);
          background-size: 200% 100%;
          animation: gpshop-shimmer 1.4s linear infinite;
        }
        @keyframes gpshop-shimmer {
          from { background-position: 200% 0; }
          to { background-position: -200% 0; }
        }

        .gpshop-mobile-filter-btn {
          display: none;
          align-items: center;
          gap: 6px;
          background: transparent;
          border: 1px solid #d4a857;
          color: #d4a857;
          padding: 7px 13px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 12px;
          cursor: pointer;
          transition: background .2s ease, color .2s ease;
        }
        .gpshop-mobile-filter-btn:hover {
          background: linear-gradient(135deg, #d4a857, #b58a3f);
          color: #1a1208;
        }

        .gpshop-sort {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          color: #9aa0a8;
        }
        .gpshop-sort select {
          background: #0b0b0c;
          border: 1px solid rgba(212, 168, 87, 0.25);
          border-radius: 8px;
          padding: 7px 30px 7px 12px;
          font-size: 12px;
          color: #fff;
          font-weight: 500;
          cursor: pointer;
          outline: none;
          appearance: none;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23d4a857' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>");
          background-repeat: no-repeat;
          background-position: right 10px center;
          transition: border-color .2s ease, box-shadow .2s ease;
        }
        .gpshop-sort select:focus {
          border-color: #d4a857;
          box-shadow: 0 0 0 3px rgba(212, 168, 87, 0.15);
        }
        .gpshop-sort select option {
          background: #15110a;
          color: #fff;
        }

        .gpshop-empty {
          background: #15110a;
          border: 1px dashed rgba(212, 168, 87, 0.3);
          border-radius: 14px;
          padding: 50px 24px;
          text-align: center;
        }
        .gpshop-empty-icon {
          color: #d4a857;
          margin-bottom: 14px;
        }
        .gpshop-empty h3 {
          font-size: 18px;
          color: #fff;
          margin: 0 0 6px;
          font-weight: 700;
        }
        .gpshop-empty p { color: #9aa0a8; margin: 0 0 18px; font-size: 13px; }
        .gpshop-empty-btn {
          background: linear-gradient(135deg, #d4a857, #b58a3f);
          color: #1a1208;
          border: none;
          padding: 10px 22px;
          border-radius: 10px;
          font-weight: 700;
          font-size: 13px;
          cursor: pointer;
          transition: filter .2s ease, transform .2s ease;
        }
        .gpshop-empty-btn:hover { filter: brightness(1.05); transform: translateY(-1px); }

        .gpshop-pagination .MuiPaginationItem-root {
          color: #cfd2d6;
        }
        .gpshop-pagination .MuiPaginationItem-root:hover {
          background: rgba(212, 168, 87, 0.15);
        }
        .gpshop-pagination .MuiPaginationItem-root.Mui-selected {
          background: linear-gradient(135deg, #d4a857, #b58a3f) !important;
          color: #1a1208 !important;
          font-weight: 700;
        }
        .gpshop-pagination .MuiPaginationItem-root.Mui-selected:hover {
          background: linear-gradient(135deg, #f1cf85, #d4a857) !important;
        }

        @media (max-width: 991px) {
          .gpshop-mobile-filter-btn { display: inline-flex; }
        }
        @media (max-width: 575px) {
          .gpshop-toolbar {
            padding: 10px 12px;
            gap: 10px;
          }
          .gpshop-count-range { display: none; }
        }
      `}</style>
    </div>
  );
};

export default FilterAllProduct;
